import { useQuery } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { fetchLandingPageBySubdomain } from '../api/landingPageService';
import { sourceFor } from '../config/source';

export function useLandingPage(subdomain: string | null) {
  return useQuery({
    queryKey: ['landingPage', subdomain, subdomain ? sourceFor(subdomain) : null],
    queryFn: () => fetchLandingPageBySubdomain(subdomain!),
    enabled: !!subdomain, // Only run query if subdomain exists
    staleTime: 5 * 60 * 1000, // 5 minutes
    // A missing page stays missing: say so at once rather than after two retries.
    retry: (failures, error) => !(isAxiosError(error) && error.response?.status === 404) && failures < 2,
  });
}
